import {
  LayoutDashboard,
  ListTodo,
  Building2,
  Users,
  ClipboardList,
  Settings2,
  Table2,
  Users2,
  UsersRound,
  MessageSquareQuote,
  Receipt,
  FolderArchive,
  Calculator,
  BookOpen,
  PieChart,
  MessagesSquare,
  Inbox,
  Wrench,
  Clock,
  BedDouble,
  CalendarClock,
  CalendarRange,
} from "lucide-react";

export const ROLE_LABELS = {
  admin: "Administrator",
  regional: "Regional Manager",
  finance: "Finance / Accounts",
  hr: "Human Resources",
  gm: "General Manager",
  employee: "Employee",
  owner: "Owner (Read-only)",
};

export const ALL_ROLES = Object.keys(ROLE_LABELS);

// Navigation items with allowed roles
export const NAV_ITEMS = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, color: "#6366f1", roles: ALL_ROLES },
  {
    to: "/portfolio",
    label: "Owner Dashboard",
    icon: PieChart,
    color: "#8b5cf6",
    roles: ["admin", "regional", "finance", "owner"],
  },
  {
    to: "/properties",
    label: "Properties",
    icon: Building2,
    color: "#3b82f6",
    roles: ["admin", "regional", "finance", "hr", "gm", "owner"],
  },
  {
    to: "/daily-reports",
    label: "Daily Report Entry",
    icon: ClipboardList,
    color: "#0ea5e9",
    roles: ["admin", "regional", "finance", "gm", "owner"],
  },
  {
    to: "/monthly-report",
    label: "Monthly Report",
    icon: Table2,
    color: "#06b6d4",
    roles: ["admin", "regional", "finance", "gm", "owner"],
  },
  {
    to: "/payroll",
    label: "Payroll Analysis",
    icon: Users2,
    color: "#14b8a6",
    roles: ["admin", "regional", "finance", "gm", "owner"],
  },
  {
    to: "/payroll-sheet",
    label: "Payroll Sheet",
    icon: CalendarClock,
    color: "#10b981",
    roles: ["admin", "regional", "finance", "gm", "hr"],
  },
  {
    to: "/guest-comments",
    label: "Guest Scores",
    icon: MessageSquareQuote,
    color: "#f59e0b",
    roles: ["admin", "regional", "finance", "gm", "hr", "owner"],
  },
  {
    to: "/employees",
    label: "Employees",
    icon: UsersRound,
    color: "#f97316",
    roles: ["admin", "regional", "hr", "gm", "finance"],
  },
  {
    to: "/time-clock",
    label: "Time Clock",
    icon: Clock,
    color: "#f43f5e",
    roles: ["admin", "regional", "hr", "gm", "finance"],
  },
  {
    to: "/schedule",
    label: "Schedule",
    icon: CalendarRange,
    color: "#84cc16",
    roles: ["admin", "regional", "hr", "gm", "finance"],
  },
  {
    to: "/invoices",
    label: "Invoices, Receipts & Checks",
    icon: Receipt,
    color: "#22c55e",
    roles: ["admin", "regional", "finance", "gm"],
  },
  {
    to: "/chat",
    label: "Team Chat",
    icon: MessagesSquare,
    color: "#d946ef",
    section: "Communications",
    roles: ["admin", "regional", "finance", "hr", "gm", "employee"],
  },
  {
    to: "/tasks",
    label: "Tasks",
    icon: ListTodo,
    color: "#ef4444",
    section: "Communications",
    roles: ["admin", "regional", "gm", "sales"],
  },
  {
    to: "/requests",
    label: "Requests",
    icon: Inbox,
    color: "#a855f7",
    section: "Communications",
    roles: ["admin", "regional", "finance", "hr", "gm", "owner"],
  },
  {
    to: "/maintenance",
    label: "Maintenance",
    icon: Wrench,
    color: "#eab308",
    section: "Communications",
    roles: ["admin", "regional", "finance", "hr", "gm", "employee"],
  },
  {
    to: "/housekeeping",
    label: "Housekeeping",
    icon: BedDouble,
    color: "#ec4899",
    section: "Communications",
    roles: ["admin", "regional", "finance", "hr", "gm", "employee"],
  },
  {
    to: "/documents",
    label: "Document Center",
    icon: FolderArchive,
    color: "#0ea5e9",
    section: "Documents & Records",
    roles: ["admin", "regional", "finance", "gm", "owner"],
  },
  {
    to: "/accounting",
    label: "Accounting & P&L",
    icon: Calculator,
    color: "#0d9488",
    section: "Documents & Records",
    roles: ["admin", "regional", "finance"],
  },
  {
    to: "/handbook",
    label: "Employee Handbook",
    icon: BookOpen,
    color: "#6366f1",
    section: "Documents & Records",
    roles: ["admin", "regional", "finance", "hr", "gm", "employee"],
  },
  {
    to: "/users",
    label: "User Management",
    icon: Users,
    color: "#64748b",
    section: "Administration",
    roles: ["admin", "regional", "hr"],
  },
  {
    to: "/report-config",
    label: "Report Builder",
    icon: Settings2,
    color: "#71717a",
    section: "Administration",
    roles: ["admin", "regional"],
  },
];

// Accent color per sidebar section header
export const SECTION_COLORS = {
  Communications: "#d946ef",
  "Documents & Records": "#0ea5e9",
  Administration: "#64748b",
};

export function can(user, roles) {
  return user && roles.includes(user.role);
}

// Pages a role gets by default (custom role pages, or built-in role lists)
export const roleDefaultPages = (roleDoc, role) =>
  NAV_ITEMS.filter((i) => (roleDoc ? (roleDoc.pages || []).includes(i.to) || (roleDoc.builtin && i.roles.includes(role)) : i.roles.includes(role))).map((i) => i.to);

// Effective pages for a user: per-user Page Access overrides the role default
export const userPages = (user, roleDoc) =>
  Array.isArray(user?.page_access) ? user.page_access : roleDefaultPages(roleDoc, user?.role);
